export const SET_SUB_MENU_POINTS = "SET_SUB_MENU_POINTS";
export const setSubMenuPoints = content => ({
    type: SET_SUB_MENU_POINTS,
    payload: content
});

export const SET_PANEL_MENU_POINTS = "SET_PANEL_MENU_POINTS";
export const setPanelMenuPoints = content => ({
    type: SET_PANEL_MENU_POINTS,
    payload: content
});